/** @format */

import React, { useEffect } from 'react';
import { Grid, Button, Typography, Paper } from '@mui/material';
import { PageContainer, SimpleDialog, ButtonLoading, PaginationComponenets, Icons } from 'components';
import createToast from 'components/Toast/Toast';
import { useStyles } from './style';
import copy from 'copy-to-clipboard';
import keysService from '../services/KeysService';
import Key from './components/Key';
import useCustomHook from '../hooks';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const services = new keysService();

export default function KeysList({ ...props }) {
  // --STATES--//
  const {
    loading,
    setLoading,
    keys,
    setKeys,
    expandedKey,
    setExpandedKey,
    openDialog,
    setOpenDialog,
    token,
    setToken,
    newTokenLoading,
    setNewTokenLoading,
    tokenShowcaseOpen,
    setTokenShowcaseOpen,
    confirmDeleteOpen,
    setConfirmDeleteOpen,
    deleteTokenLoading,
    setDeleteTokenLoading,
    currentPage, setCurrentPage,
    totalCount, setTotoalCount
  } = useCustomHook();

  // --HOOKS--//

  const classes = useStyles();
  const actionsList =
    getDynamicObjectAction([
      'contentKeyListPage',
      'getNewTokenKeyListBtn',
      'removeAllTokenKeyListBtn'
    ]);


  useEffect(() => {
    if (actionsList['contentKeyListPage']) {
      getKeys({
        page: currentPage === 0 ? 1 : currentPage,
        pageSize: 10,
        pageNumber: currentPage === 0 ? 0 : currentPage - 1,
        changeData: true,
      });
      paginationOnChange({
        page: currentPage === 0 ? 1 : currentPage,
        pageSize: 10,
        pageNumber: currentPage === 0 ? 0 : currentPage - 1,
        changeData: true,
      });
    }
  }, [currentPage]);

  // --API--//
  const getKeys = async (query) => {
    const params = {
      offset: query ? query?.pageNumber * query?.pageSize : page * size,
      size: query ? query?.pageSize : size,
    };
    try {
      setLoading(true);
      const result = await services.getList(params);
      const { data } = result;
      if (data?.status === 200 && !data?.result?.hasError) {
        setKeys(data?.result.clients);
        setTotoalCount(data?.result?.total)
        setExpandedKey(-1)
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const paginationOnChange = async (param) => {
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میش
      setCurrentPage(param?.page == 0 ? 1 : param?.page);
    }
  };
  const getNewToken = async () => {
    try {
      setConfirmDeleteOpen(false);
      setNewTokenLoading(true);
      const result = await services.getToken();
      setToken(result?.data?.result?.apiToken);
      setNewTokenLoading(false);
      createToast('موفق', 'توکن جدید با موفقیت ایجاد شد', 'success');
      setTokenShowcaseOpen(true);
    } catch (error) {
      setNewTokenLoading(false);
    }
  };

  const deleteTokens = async () => {
    try {
      setDeleteTokenLoading(true);
      await services.deleteAllToken();
      createToast('موفق', 'همه توکن‌ها با موفقیت حذف شدند', 'success');
      setDeleteTokenLoading(false);
      handleCloseModal();
    } catch (error) {
      setDeleteTokenLoading(false);
    }
  };

  // -- OTHER FUNCTIONS --//
  const removeKey = (clientID) => {
    const tempkeys = [...keys];
    const keyIndex = tempkeys.findIndex((item) => item?.client_id === clientID);
    tempkeys.splice(keyIndex, 1);
    setKeys([...tempkeys]);
  };

  const copyItem = async (v) => {
    try {
      copy(v);
      createToast('موفق', 'توکن کپی شد.', 'success');
    } catch (e) {
      console.log(e);
      createToast('خطا', 'خطا در کپی‌کردن توکن.', 'danger');
    }
  };

  const handleCloseModal = () => {
    setOpenDialog(false);
    setToken(null);
    setNewTokenLoading(false);
    setTokenShowcaseOpen(false);
    setConfirmDeleteOpen(false);
    setDeleteTokenLoading(false);
  };
  const hintText = `کسب‌وکار می تواند تعداد دلخواه اپلیکشن (client) متصل به پلتفرم داشته باشد. هر اپلیکیشن دارای یک سری کلید اتصال شامل client_id و client_secret و api_token است که برای فراخوانی سرویس ها (API) استفاده می شوند.`;

  return (
    <>
      <PageContainer
        title="لیست کلیدها"
        meta={
          <>
            {(actionsList['getNewTokenKeyListBtn'] || actionsList['removeAllTokenKeyListBtn']) && (
              <Button
                startIcon={<Icons icon="Key" color="#ffffff" size="20" />}
                onClick={() => setOpenDialog(true)}
                color="primary"
                variant="contained"
              >
                اطلاعات توکن کسب‌وکار
              </Button>
            )}
          </>

        }
        description={hintText}
        breadcrumbs={constBreadCrumbsTitle.KEYS_LIST}
        loading={loading}
      >

        {actionsList['contentKeyListPage'] && (
          <>
            {keys?.map((v, k) => (
              <Key
                expanded={expandedKey}
                onExpand={(newK) => setExpandedKey(newK)}
                key={v?.client_id}
                itemKey={k}
                item={v}
                popKey={(cid) => removeKey(cid)}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            ))}
            {keys?.length > 0 && (
              <PaginationComponenets
                itemsPerPage={10}
                currentPage={currentPage}
                pageCount={totalCount}
                onChange={paginationOnChange}
                removePrePage={true}
                localCall={true}
              />
            )}
          </>
        )}
        <SimpleDialog
          fullWidth
          maxWidth="sm"
          open={openDialog}
          title="اطلاعات توکن کسب‌وکار"
          onClose={handleCloseModal}
          icon={<Icons icon="lock" color="#2b3990" size="23" />}
        >
          <Typography className={classes.modalText}>
            برای فراخوانی سرویس های پاد شما نیاز به داشتن توکن دارید. برای دریافت توکن جدید روی
            دکمه پایین کلیک کنید.
          </Typography>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.actionsButtons}
          >
            {actionsList['getNewTokenKeyListBtn'] && (
              <ButtonLoading
                className={classes.newTokenButton}
                onClick={() => getNewToken()}
                startIcon={<Icons icon="Refresh" color={newTokenLoading ? "#ccc" : "#2b3990"} size="17" />}
                variant="outlined"
                loading={newTokenLoading}
                name="دریافت توکن جدید"
              />
            )}
            {actionsList['removeAllTokenKeyListBtn'] && (
              <Button
                className={classes.removeTokensButton}
                onClick={() => {
                  setTokenShowcaseOpen(false);
                  setConfirmDeleteOpen(true);
                }}
                startIcon={<Icons icon="Trash" color="#ef5350" size="20" />}
              >
                حذف همه توکن‌ها
              </Button>
            )}
          </Grid>
          {/* Confirm Delete Tokens */}
          {confirmDeleteOpen ? (
            <Paper className={classes.detailPaper}>
              <Typography className={classes.confirmDeleteTitle}>
                آیا از حذف تمامی توکن‌ها مطمئن هستید؟
              </Typography>
              <Typography className={classes.confirmDeleteText}>
                با تایید حذف، تمامی توکن‌های ساخته‌شده‌ی قبلی (تمامی دسترسی‌های قبلی) حذف شده و
                قابل بازگشت نیستند.
              </Typography>

              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={classes.actionsButtons}
              >
                <Button className={classes.cancelDeleteButton} onClick={handleCloseModal}>
                  نه، منصرف شدم
                </Button>
                <ButtonLoading
                  onClick={deleteTokens}
                  variant="outlined"
                  loading={deleteTokenLoading}
                  name="بله، حذف کن"
                />
              </Grid>
            </Paper>
          ) : null}

          {/* Token Detail */}
          {tokenShowcaseOpen ? (
            <Paper className={classes.detailPaper}>
              <Typography className={classes.newTokenTitle}>توکن جدید:</Typography>
              <Typography className={classes.newTokenAlert}>
                توجه: توکن زیر تنها یک‌ بار نمایش داده می‌شود. لطفا آن را در سیستم خود ذخیره
                نمایید.
              </Typography>
              <Typography className={classes.newTokenText}>{token}</Typography>

              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={classes.actionsButtons}
              >
                <Button onClick={() => copyItem(token)} variant="outlined">
                  کپی کردن توکن
                </Button>
              </Grid>
            </Paper>
          ) : null}
        </SimpleDialog>
      </PageContainer>

    </>
  );
}

// TODO: add prop-types
